import React from 'react'
import classnames from 'classnames'
import Moment from 'moment'
import { FormMoney, FormTime, FormButton, FormSelect } from '@myxplor/forms'
import { DeleteIcon, CloseIcon } from '@myxplor/icons'
import { Pill } from '@myxplor/ui'
import { feeTypes, feeIsHourly, valdiateSessionLength, timePattern } from './helpers'
import { DaySessionWarning } from './day-session-warning'

const DaySessionsEdit = ({
  onChange,
  session,
  nameBase,
  removeKey,
  isEditing,
  changeEditingSession,
  resetEditingSession,
  careEnrolmentOptions,
}) => {
  const isHourlySession = feeIsHourly(session.feeFrequency)

  if (!isEditing) {
    return (
      <li className="weekDay--session weekDay--session__clickable" onClick={changeEditingSession}>
        <Pill
          warning={isHourlySession}
          error={!valdiateSessionLength(session)}
          title={isHourlySession ? 'This is an hourly session' : ''}
          noUpperCase>
          {Moment(session.startTime, timePattern).format('h:mma')}
          {' - '}
          {Moment(session.endTime, timePattern).format('h:mma')}, ${session.standardAmount}
          {isHourlySession && '/hr'}
        </Pill>
      </li>
    )
  }

  return (
    <li>
      <fieldset
        className={classnames({
          'weekDay--sessionFields': true,
          'weekDay--sessionFields__hourly': isHourlySession,
        })}>
        <FormButton right onClick={resetEditingSession}>
          <CloseIcon />
        </FormButton>

        <FormTime
          name={nameBase + '.startTime'}
          label="Start"
          onChange={onChange}
          value={session.startTime}
          compact
          required
        />
        <FormTime
          name={nameBase + '.endTime'}
          label="Finish"
          onChange={onChange}
          value={session.endTime}
          compact
          required
        />

        {!valdiateSessionLength(session) && <DaySessionWarning />}

        <FormSelect
          name={nameBase + '.feeFrequency'}
          label="Frequency"
          options={feeTypes}
          value={session.feeFrequency || feeTypes[0].value}
          onChange={onChange}
        />

        <FormMoney
          name={nameBase + '.standardAmount'}
          value={session.standardAmount}
          onChange={onChange}
          label={`Cost per ${isHourlySession ? 'hour' : 'session'}`}
          compact
          required
        />

        {careEnrolmentOptions.length > 1 && (
          <FormSelect
            name={nameBase + '.care_id'}
            options={careEnrolmentOptions}
            value={session.care_id}
            label="Care Profile"
            onChange={onChange}
            compact
            required
          />
        )}

        <FormButton
          className="weekDay--removeSession"
          left
          onClick={() => {
            removeKey(nameBase)
            resetEditingSession()
          }}>
          <DeleteIcon left />
          Remove Session
        </FormButton>
      </fieldset>
    </li>
  )
}

export default DaySessionsEdit



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/day-sessions.jsx